export const defaultRedirectUrl = process.env.REACT_APP_LOGOUT_URL ? process.env.REACT_APP_LOGOUT_URL : `${process.env.PUBLIC_URL}/auth/login`
